/**
 * CHRISTMAS_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Christmas / Holiday music.
 * Traits:
 * - High Register Focus (Glockenspiel, Sleigh Bells, Piccolo)
 * - Major / Lydian Tonality (Consonant)
 * - Rhythmic Lock (Sleigh Bell shuffle)
 * - Moderate Pacing
 */

import { BASE_ARCHETYPE } from './BaseArchetype.js';

export const CHRISTMAS_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    // Voice Distribution: Top Heavy.
    // Sparkle (High) + Warmth (Mid). Less focus on heavy bass.
    voiceDistribution: {
        ...BASE_ARCHETYPE.voiceDistribution,
        low: 0.20,
        mid: 0.40,
        high: 0.40, // Bell / High Woodwind focus
        tolerance: 0.15
    },

    // Dynamic Range: Moderate.
    // Joyful but not aggressive.
    dynamicRange: {
        ...BASE_ARCHETYPE.dynamicRange,
        minVariance: 0.10,
        targetVariance: 0.20,
        dynamicShape: 'swell'
    },

    // Interval Entropy: Melodic / Tune-ful.
    intervalEntropy: {
        ...BASE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.65,
        tolerance: 0.15
    },

    // Harmonic Consonance: Very High.
    // Sweet, sugary harmony.
    harmonicConsonance: {
        ...BASE_ARCHETYPE.harmonicConsonance,
        polarity: 'consonant',
        weight: 0.3
    },

    // Rhythmic Lock: High.
    // Sleigh bells set the grid.
    rhythmicLock: {
        ...BASE_ARCHETYPE.rhythmicLock,
        target: 0.85,
        weight: 0.2
    }
};
